// src/components/HomePage.jsx
import React from "react";
import "./home.css";
import genericCalendar from "../../assets/generic-calendar.png";
import CrociImage from "../../assets/Croci.jpeg";
import LeaningImage from "../../assets/Leaning.jpg";

export default function HomePage({ onViewSelect }) {
  const teamMembers = [
    { name: "Amy", role: "Founder", initials: "A" },
    { name: "Caitlin", role: "Developer", image: CrociImage },
    { name: "Sarah", role: "Developer", image: LeaningImage },
    { name: "Sara", role: "Developer", initials: "S" },
    { name: "Grace", role: "Developer", initials: "G" },
  ];

  return (
    <div className="home-wrapper">

      {/* Navigation */}
      <nav className="navbar">
        <h1 className="logo">Do You Wanna Go?</h1>
        <div className="nav-actions">
          <button
            className="nav-button"
            onClick={() => {
              sessionStorage.setItem("authMode", "Login");
              onViewSelect("loginSignup");
            }}
          >
            Login
          </button>
          <button 
            className="nav-button primary"
            onClick={() => onViewSelect("loginSignup")}
          >
            Sign Up
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-left">
          <h2 className="hero-title">
            Discover. Host. Experience.
          </h2>
          <p className="hero-subtitle">
            A centralized event platform connecting communities, creators, 
            and businesses in one seamless ecosystem.
          </p>

          <div className="hero-buttons">
            <button 
              className="home-button"
              onClick={() => onViewSelect("loginSignup")}
            >
              Explore Events
            </button>
            <button 
              className="home-button outline"
              onClick={() => onViewSelect("loginSignup")}
            >
              Host an Event
            </button>
          </div>
        </div>

        <div className="hero-right">
          <img 
            src={genericCalendar} 
            alt="Events and community" 
            className="hero-image"
          />
        </div>
      </section>

       {/* How it works */}
      <section className="how-section">
        <h3 className="section-title center">How It Works</h3>

        <div className="how-steps">
          <div className="how-step">
            <div className="step-number">1</div>
            <h4>Discover</h4>
            <p>
              Find events tailored to your interests and location.
            </p>
          </div>

          <div className="how-step">
            <div className="step-number">2</div>
            <h4>Connect</h4>
            <p>
              RSVP, interact, and engage with your community.
            </p>
          </div>

          <div className="how-step">
            <div className="step-number">3</div>
            <h4>Grow</h4>
            <p>
              Expand your reach and gain insights with ease.
            </p>
          </div>
        </div>
      </section>

      {/* Users & Businesses */}
      <section className="audience-section">

        <div className="audience-card">
          <h3>For Event-Goers</h3>
          <ul>
            <li>Discover and RSVP to local events</li>
            <li>Track upcoming activities in one place</li>
            <li>Engage with your community</li>
          </ul>
          <button
            className="home-button"
            onClick={() => onViewSelect("loginSignup")}
          >
            Start Exploring
          </button>
        </div>

        <div className="audience-card">
          <h3>For Businesses & Organizations</h3>
          <ul>
            <li>Create, manage, and promote events</li>
            <li>Leverage analytics to maximize reach</li>
            <li>Gain insights to grow your audience</li>
          </ul>
          <button
            className="home-button"
            onClick={() => onViewSelect("loginSignup")}
          >
            Post Your Event
          </button>
        </div>

      </section>

      {/* Why */}
      <section className="why-section">
        <h3 className="section-title center">
          Why Choose Do You Wanna Go?
        </h3>

        <div className="why-grid">

          <div className="why-box">
            <h4>Centralized Calendar</h4>
            <p>
              All events in one place — no more searching.
            </p>
          </div>

          <div className="why-box">
            <h4>Smart Personalization</h4>
            <p>
              Recommendations powered by your interests and engagement.
            </p>
          </div>

          <div className="why-box">
            <h4>Business Analytics</h4>
            <p>
              Data-driven insights to optimize marketing and maximize turnout.
            </p>
          </div>

          <div className="why-box">
            <h4>Seamless Management</h4>
            <p>
              Create, manage, and promote events with intuitive tools.
            </p>
          </div>

        </div>
      </section>
      
      {/* Our Team */}
      <section className="team-section">
        <h3 className="section-title center">Meet the Team</h3>

        <div className="team-grid">
          {teamMembers.map((member) => (
            <article className="team-member" key={member.name}>
              <div className={`team-avatar${member.image ? "" : " placeholder"}`}>
                {member.image ? (
                  <img src={member.image} alt={member.name} />
                ) : (
                  <span>{member.initials}</span>
                )}
              </div>
              <h4 className="team-name">{member.name}</h4>
              <p className="team-role">{member.role}</p>
            </article>
          ))}
        </div>
      </section>

      {/* Call To Action */}
      <section className="cta-section">
        <h3 className="cta-title">Ready to Experience More?</h3>
        <p className="cta-subtext">
          Join the community and start discovering or hosting today.
        </p>
        <button 
          className="home-button"
          onClick={() => onViewSelect("loginSignup")}
        >
          Create Your Account
        </button>
      </section>

      {/* Access by User Type
        <div className="section-box">
          <h3 className="login-title">User Type Access</h3>
          <button className="home-button" onClick={() => onViewSelect('user')}>
            User View
          </button>
          <button className="home-button" onClick={() => onViewSelect('businessHome')}>
            Business View
          </button>
          <button className="home-button" onClick={() => onViewSelect('admin')}>
            Admin View
          </button>
        </div>
      */}

      {/* Footer */}
      <footer className="footer">
        <p>© 2026 Do You Wanna Go. All rights reserved.</p>
      </footer>

    </div>
  );
}
